import { Platform } from "quasar";

export default function useIsMobile() {
  const isMobile = Platform.is.mobile && !Platform.is.ipad ? true : false;
  return isMobile;
}
